import { PropsWithChildren } from 'react';
import { ApolloProvider } from '@apollo/client';

import { client } from '../../api/apollo';

export const AuthenticatedApp = ({ children }: PropsWithChildren) => {
	return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
